// Game and portfolio links carry the name and the id (/game/space-race-17984202): the id opens the item, the name is for people.

const MAX_NAME_PART = 60;

// The readable half of a link: lowercase, accents dropped, every run of other characters one hyphen.
// Cut by characters, not UTF-16 units, so a letter like 𝔸 is never split in half (half a letter can't go in a URL).
export const linkName = (name) => Array.from(String(name || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '').normalize('NFC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, ''))
    .slice(0, MAX_NAME_PART)
    .join('')
    .replace(/-+$/, '');

// An item's link segment: "<name part>-<id>", or the id alone when the name leaves nothing.
export const entitySegment = (name, id) => {
    const key = id == null ? '' : String(id);
    const part = linkName(name);
    if (!key) return part;
    return part ? `${part}-${key}` : key;
};

// The item a segment opens: by its whole id, by the (longest) id it ends in, else by an old name-only link.
export const findBySegment = (items, segment, legacySegmentOf) => {
    if (!segment) return null;
    const list = (Array.isArray(items) ? items : []).filter((item) => item && item.id != null);
    const exact = list.find((item) => String(item.id) === segment);
    if (exact) return exact;
    const tail = list
        .filter((item) => segment.endsWith(`-${item.id}`))
        .sort((a, b) => String(b.id).length - String(a.id).length)[0];
    if (tail) return tail;
    return legacySegmentOf ? list.find((item) => legacySegmentOf(item) === segment) || null : null;
};
